/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React from 'react';
// material
import Group from 'material/group/group';
import CTAs from 'material/ctas/ctas';
import BackToEmbedsCTA from 'material/ctas/backtoembeds/backtoembeds';
import EmbedName from 'material/embeds/embedname/embedname_container';
import Preview from 'material/ctas/preview/preview_container';
// styles
import injectSheet from 'react-jss';
import styles from 'material/embeds/embedcontrols/embedcontrols_styles';



/* ========== ~~~~~~~~~~ EMBED CONTROLS : CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
const EmbedControls = (props) => {
	const _renderCTAs = () => {
		const ctas =
				(<Group>
					<CTAs>
						<Preview />
					</CTAs>
				</Group>);
        return props.currentStepPage !== 'placement' || !props.isNewEmbedFlow ? ctas : null;
    };
	const getClientEmbedsData = () => props.getClientEmbedsData(props.accountUUID);
	return (
		<div className={`embedcontrols ${props.classes.embedcontrols} embedChangeDetected-${!props.isNewEmbedFlow && props.changeDetected}`}>
			<Group>
				<BackToEmbedsCTA getClientEmbedsData={getClientEmbedsData} />
			</Group>
			<Group>
        		<EmbedName handleSaveEmbed={props.handleSaveEmbed} />
        	</Group>
			{_renderCTAs()}
        </div>
	);
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(EmbedControls);